import React from 'react'
import { NmxIcon } from '@nominex/dex-uikit'
import LoadableValue from 'components/LoadableValue'
import { useNmxUsdtPrice } from 'hooks/useUsdtPrice'
import { formatNumber } from 'utils/formatters'

export const NmxBreakdown: React.FC = () => {
  const nmxPrice = Number((useNmxUsdtPrice() || 0).toFixed(8))

  return (
    <div className="flex items-center gap-8 rounded-10 gradient-dark-blue h-[40px] px-12">
      <NmxIcon width="18px" />
      <LoadableValue loading={!nmxPrice} fontSize="16px" width="47px" height="16px" bold>
        {formatNumber(nmxPrice, 'toUSD')}
      </LoadableValue>
    </div>
  )
}
